import { TermsAndConditionsDialogEffects } from '@terms-and-conditions/effects/terms-and-conditions-dialog/terms-and-conditions-dialog.effects';

export const termsAndconditionsEffects = [TermsAndConditionsDialogEffects];
